import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { SectionHeading } from "./shared";

export default function FaqSection({ t }) {
  const [open, setOpen] = useState(0);
  return (
    <section className="bg-[#FAF5EE] py-16 sm:py-24" data-testid="weddings-faq">
      <div className="max-w-3xl mx-auto px-5 sm:px-6">
        <SectionHeading eyebrow="FAQ" title={t.faqTitle} />
        <div className="space-y-2.5 sm:space-y-3">
          {t.faq.map((f, i) => (
            <div key={i} className="bg-[#FAF5EE] rounded-sm border border-[#EFE4D2] overflow-hidden transition-all" data-testid={`weddings-faq-${i}`}>
              <button onClick={() => setOpen(open === i ? -1 : i)}
                      className="w-full text-left p-4 sm:p-6 flex items-center justify-between gap-3 sm:gap-4 hover:bg-[#F5EDE0] transition">
                <span className="font-medium text-[#1F1815] text-[14px] sm:text-[15px]">{f.q}</span>
                <ChevronRight className={`w-5 h-5 text-[#C9A87C] shrink-0 transition-transform ${open === i ? "rotate-90" : ""}`} />
              </button>
              {open === i && <div className="px-4 sm:px-6 pb-5 sm:pb-6 text-[#6B5D4F] leading-relaxed font-light text-[14px] sm:text-[15px]">{f.a}</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
